export default __webpack_public_path__ + "static/media/hero-image-2-mobile@2x.9a6fe71c.png";